import React, { useState } from 'react';
import axios from 'axios';
import './FieldRulesPanel.css';
import RequiredRuleForm from './RequiredRuleForm';
import ConditionalRuleForm from './ConditionalRuleForm';
import UnconditionalRuleForm from './UnconditionalRuleForm';
import AdditionalRulesSection from './AdditionalRulesSection';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function FieldRulesPanel({ selectedField, fields, rules, docType, docVersion, onRuleUpdate, showToast, onConditionalRuleModeChange, onUnconditionalRuleModeChange }) {
  const [activeTab, setActiveTab] = useState('required');

  // Show message if no document is selected
  if (!docType) {
    return (
      <div className="field-rules-panel">
        <div className="panel-header">
          <h2>Field Rules</h2>
          <p className="panel-subtitle">Search and download a document to start configuring validation rules</p>
        </div>
      </div>
    );
  }

  // Allow conditional and unconditional rules tabs to work without selected field
  const tabsThatDontRequireField = ['conditional', 'unconditional'];
  if (!selectedField && !tabsThatDontRequireField.includes(activeTab)) {
    return (
      <div className="field-rules-panel">
        <div className="panel-header">
          <h2>Field Rules</h2>
          <p className="panel-subtitle">Document: <strong>{docType}</strong>{docVersion && docVersion !== 'no_version' && ` (${docVersion})`}</p>
          <p className="panel-subtitle" style={{ marginTop: '0.5rem' }}>Select a field on the document to configure rules</p>
        </div>
        <div className="rules-tabs">
          <button
            className={`tab-button ${activeTab === 'required' ? 'active' : ''}`}
            onClick={() => setActiveTab('required')}
          >
            Required Rules
          </button>
          <button
            className={`tab-button ${activeTab === 'conditional' ? 'active' : ''}`}
            onClick={() => setActiveTab('conditional')}
          >
            Conditional Rules
          </button>
          <button
            className={`tab-button ${activeTab === 'unconditional' ? 'active' : ''}`}
            onClick={() => setActiveTab('unconditional')}
          >
            Unconditional Rules
          </button>
        </div>
        <div className="rules-content">
          {activeTab === 'conditional' && (
            <ConditionalRuleForm
              fields={fields || []}
              rules={rules?.conditional_rules || []}
              docType={docType}
              docVersion={docVersion}
              onRuleUpdate={onRuleUpdate}
              showToast={showToast}
              onFieldSelectionModeChange={onConditionalRuleModeChange}
            />
          )}
          {activeTab === 'unconditional' && (
            <UnconditionalRuleForm
              fields={fields || []}
              rules={rules?.unconditional_rules || []}
              docType={docType}
              docVersion={docVersion}
              onRuleUpdate={onRuleUpdate}
              showToast={showToast}
              onFieldSelectionModeChange={onUnconditionalRuleModeChange}
            />
          )}
        </div>
        <div className="additional-rules-wrapper">
          <AdditionalRulesSection
            rules={rules}
            docType={docType}
            docVersion={docVersion}
            onRuleUpdate={onRuleUpdate}
            showToast={showToast}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="field-rules-panel">
      <div className="panel-header">
        <h2>Field Rules</h2>
        <p className="panel-subtitle">Document: <strong>{docType}</strong>{docVersion && docVersion !== 'no_version' && ` (${docVersion})`}</p>
        <p className="panel-subtitle" style={{ marginTop: '0.5rem' }}>Configure validation and extraction rules for selected fields.</p>
      </div>

      {selectedField && (
        <div className="active-field">
          <div className="active-field-info">
            <span className="field-name" title={selectedField.id}>{selectedField.name}</span>
          </div>
        </div>
      )}

      <div className="rules-tabs">
        <button
          className={`tab-button ${activeTab === 'required' ? 'active' : ''}`}
          onClick={() => setActiveTab('required')}
        >
          Required Rules
        </button>
        <button
          className={`tab-button ${activeTab === 'conditional' ? 'active' : ''}`}
          onClick={() => setActiveTab('conditional')}
        >
          Conditional Rules
        </button>
        <button
          className={`tab-button ${activeTab === 'unconditional' ? 'active' : ''}`}
          onClick={() => setActiveTab('unconditional')}
        >
          Unconditional Rules
        </button>
      </div>

      <div className="rules-content">
        {activeTab === 'required' && (
          <RequiredRuleForm
            selectedField={selectedField}
            rules={rules.required_fields}
            docType={docType}
            docVersion={docVersion}
            onRuleUpdate={onRuleUpdate}
            showToast={showToast}
          />
        )}
        {activeTab === 'conditional' && (
          <ConditionalRuleForm
            fields={fields || []}
            rules={rules?.conditional_rules || []}
            docType={docType}
            docVersion={docVersion}
            onRuleUpdate={onRuleUpdate}
            showToast={showToast}
            onFieldSelectionModeChange={onConditionalRuleModeChange}
          />
        )}
        {activeTab === 'unconditional' && (
          <UnconditionalRuleForm
            fields={fields || []}
            rules={rules?.unconditional_rules || []}
            docType={docType}
            docVersion={docVersion}
            onRuleUpdate={onRuleUpdate}
            showToast={showToast}
            onFieldSelectionModeChange={onUnconditionalRuleModeChange}
          />
        )}
      </div>
      
      <div className="additional-rules-wrapper">
        <AdditionalRulesSection
          rules={rules}
          docType={docType}
          docVersion={docVersion}
          onRuleUpdate={onRuleUpdate}
          showToast={showToast}
        />
      </div>
    </div>
  );
}

export default FieldRulesPanel;

